module.exports = __webpack_public_path__ + "img/thumbnail_WestAfricanLion_j_normal.02cc7cb4.png";